import { Control, Controller, FieldError, UseFormSetValue } from "react-hook-form";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Typography } from "@mui/material";


interface DropZoneFieldProps {
    name: string,
    multiple: boolean,
    control: Control<any>,
    setValue: UseFormSetValue<any>,
    size?: 'small' | 'medium', // Nuevo prop para el tamaño del Dropzone
}

interface DropzoneProps {
    onChange: (...event: any[]) => void,
    multiple: boolean,
    name: string,
    setValue: UseFormSetValue<any>,
    error?: FieldError,
    size: 'small' | 'medium', // Nuevo prop para el tamaño del Dropzone
}

export const DropzoneField = ({
                                  name,
                                  control,
                                  size = 'medium', // Establecer 'medium' como valor por defecto
                                  ...rest
                              }: DropZoneFieldProps) => {
    return (
        <Controller
            render={({ field: { onChange }, fieldState: { error } }) => (
                <div>
                    <Dropzone
                        onChange={e =>
                            onChange(rest.multiple ? e.target.files : e.target.files[0])
                        }
                        name={name}
                        error={error}
                        size={size} // Pasar el tamaño al Dropzone
                        {...rest}
                    />
                    {error &&
                        <Typography variant='caption' color='error'>{error?.message}</Typography>
                    }
                </div>
            )}
            name={name}
            control={control}
            defaultValue=""
        />
    );
};

const Dropzone = ({ onChange, setValue, name, error, size, ...rest }: DropzoneProps) => {

    const onDrop = useCallback((acceptedFiles: any) => {
        setValue(name, rest.multiple ? acceptedFiles : acceptedFiles.pop())
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, ...rest });

    const dropzoneBox = {
        height: size === 'small' ? '75px' : '200px', // Ajustar la altura según el tamaño
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        cursor: 'pointer',
        color: '#cccccc',
        borderColor: 'grey',
        borderRadius: '10px',
    }
    const borderDashed = {
        borderStyle: 'dashed',
        borderWidth: '4px'
    }

    const borderSolid = {
        borderStyle: 'solid', borderWidth: '4px'
    }

    const borderError = {
        borderColor: 'red'
    }

    const otherStyles = isDragActive ? borderDashed : borderSolid
    const errorStyle = error && borderError

    return (
        <Box {...getRootProps()}
             sx={{
                 ...dropzoneBox,
                 ...otherStyles,
                 ...errorStyle
             }}
        >
            <input {...getInputProps({ onChange })} />
            {isDragActive ? (
                <p>Arrastrar aquí...</p>
            ) : (
                <p>Arrastrar aquí o hacer click para seleccionar archivos</p>
            )}
        </Box>
    );
};

